exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-input-password-append[data-v-286e2c69]{cursor:pointer}#birth_year[data-v-286e2c69]{min-width:70px}#birth_day[data-v-286e2c69],#birth_month[data-v-286e2c69]{min-width:45px}.vc-total[data-v-286e2c69]{font-size:1.3rem;font-weight:700}", ""]);

// exports
